import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: null,
  searchText: null,
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  compradorResponsavel: [],
  dataFinal: null,
  dataInicial: null,
  urgencia: [],
  grupo: [],
  situacao: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
